/**
 * common模块接口列表
 */
import {backendUrl} from '@/assets/js/config'
import axios from '@/assets/plugins/axios'

const common = {
  // 获取菜单列表
  queryMenuList (params) {
    return axios.get(`${backendUrl}/ysj/v1/menus`, params)
  },
  // 获取企业数据库 造价数据 相关菜单权限
  getPermissionBasis () {
    return axios.get(`${backendUrl}/enterprise/database/permission/user`)
  },
  // 获取企业数据库 所有产品权限
  getPermissionApplications (params) {
    params.noCache = true
    return axios.post(`${backendUrl}/enterprise/cloudApplication/permissions`, params)
  },
  // 获取登录用户对产品的权限+
  getUsePermissionApplications () {
    return axios.get(`${backendUrl}/enterprise/employees/dbrole`)
  },
  // 2. 下载帮助文档
  downloadHelpDoc () {
    return `${backendUrl}/common/help_doc`
  },
  // 3. 查询是否有新的未读消息
  getHotpointMessage () {
    return axios.get(`${backendUrl}/messages/hotpoint`)
  },
  // 3.1 清除 新消息小红点
  deleteHotpointMessage () {
    return axios.delete(`${backendUrl}/messages/hotpoint`)
  },
  // 4.1 查询 历史上传是否有新动态
  getHotpointUpload () {
    return axios.get(`${backendUrl}/upload_history/upload_hint`)
  },
  // 4.2 查询 历史上传是否有新动态 数据相关
  getHotpointUploadBigData () {
    return axios.get(`${backendUrl}/data_manage/upload_hint`)
  },
  // 4.3 清除 历史上传 小红点
  deleteHotpointUpload () {
    return axios.delete(`${backendUrl}/upload_history/upload_hint`)
  },
  // 5. 查询 我的反馈 是否有新动态
  getHotpointFeedback () {
    return axios.get(`${backendUrl}/feedback/unread_msg_num`)
  },
  // 5.1 清除 我的反馈 小红点
  deleteHotpointFeedback () {
    return axios.delete(`${backendUrl}/feedback/unread_msg_num`)
  },
  // 校验空间容量，如果返回 null 表示剩余空间容量不够
  checkCapacity (params){
    return axios.get(`${backendUrl}/workspace/check_capacity`, params)
  },
  // 获取引导页的权限
  getTips (){
    return axios.get(`${backendUrl}/user/guide`, {})
  },
  setTips (guideName){
    return axios.put(`${backendUrl}/user/guide/close?guideName=${guideName}`, {guideName: guideName})
  },
  // 获取试用中心 试用产品列表
  getTrialApps (params) {
    return axios.get(`${backendUrl}/trial/apps`, params)
  },
  // 获取项目云应用 应用列表
  getProjectsCloudApps (params) {
    return axios.get(`${backendUrl}/projects/cloud_apps`, params)
  },
  // 调用造价云的单点登录 然后重定向到目标页面
  zjySsoLogin () {
    return `${backendUrl}/user/cas_ticket`
  },
  // 获取用户是否已读新版公告状态
  getAnnouncement () {
    return axios.get(`${backendUrl}/ysj/announcement`)
  },
  // 获取用户是否已读新版公告状态
  setAnnouncement () {
    return axios.post(`${backendUrl}/ysj/announcement`)
  }

}

export default common
